import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CustomLandingFactory } from '@shared/factories/custom-landing/custom-landing.factory';
import { GlobalCfgFactory } from '@shared/factories/global-cfg/global-cfg.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { AfTranslatePipe } from '@shared/modules/translate/pipe/af-translate.pipe';
import { RichEditorComponent } from '../rich-editor/rich-editor.component';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipLawComponent } from '../tooltip-law/tooltip-law.component';
import { TooltipInfoComponent } from '../tooltip-info/tooltip-info.component';
import { NgClass } from '@angular/common';
import { TooltipInReportComponent } from "../tooltip-in-report/tooltip-in-report.component";
import { ProgressBarDirective } from '@shared/directives/progress-bar/progress-bar.directive';

@Component({
    selector: 'expanded-textarea',
    templateUrl: './expanded-textarea.component.html',
    standalone: true,
    imports: [
    NgClass,
    TooltipInfoComponent,
    TooltipLawComponent,
    TooltipModule,
    FormsModule,
    RichEditorComponent,
    AfTranslatePipe,
    TooltipInReportComponent,
    ProgressBarDirective
]
})
export class ExpandedTextareaComponent implements OnInit {
  text: string = this.dialogConfig.data.text;
  field: any = this.dialogConfig.data.field;
  concept: any = this.dialogConfig.data.concept;
  voiceRecord: any = this.dialogConfig.data.voiceRecord;
  acceptAceptation: boolean = this.dialogConfig.data.acceptAceptation;

  constructor(private globalCfg: GlobalCfgFactory,
    private commonUtilsService:CommonUtilsService,
    private modalService: ModalServiceService,
    private customLanding: CustomLandingFactory,
    private dialogRef: DynamicDialogRef<ExpandedTextareaComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  isLanding: boolean = this.customLanding.isLanding();
  skin = this.globalCfg.skin;
  tinymceOptions:any;
  startAudio: boolean = false;
  initInterval: number = 0;
  percentTime:number = 0;
  interval: any;
  expandedTextarea:any = {
    text:'',
    hideTooltipInfo: false,
    titleField: '',
    tinyMceOptions: {
      noEditable: false,
      typeView: 'rich-text',
      expanded: true,
      voiceRecord: null
    }
  }

  ngOnInit(): void {
    this.expandedTextarea.tinyMceOptions.noEditable = this.field.noEditable;
    if (this.field.fieldId === 'custom-notification-field') {
      this.expandedTextarea.tinyMceOptions.toolbar = ' undo redo | bold italic underline | alignment | bullist numlist | removeformat | link';
    }
    this.commonUtilsService.configureCustomButtonsTiny(this.field, this.expandedTextarea.tinyMceOptions);
    this.expandedTextarea.text = this.text;
    this.expandedTextarea.hideTooltipInfo = this.field.noEditable || !this.field.description || (this.field.fieldTypeId === 'rich' && this.field.isEditable);
    this.expandedTextarea.titleField = this.field.extendedLabel && this.field.extendedLabel !== ''? this.field.extendedLabel : this.field.label;
    if(this.field.inReport !== null && this.field.inReport !== undefined){
      this.expandedTextarea.inReport = this.field.inReport.indexOf('|') === -1? [this.field.inReport] : this.field.inReport.split('|')
    }
    if(this.voiceRecord?.name){
      this.configureVoiceRecord(this.voiceRecord);
    }
    this.expandedTextarea.acceptAceptation = this.acceptAceptation;
  }

  resetInput() {
    if(this.startAudio){
      this.stopInterval()
    }
    this.expandedTextarea.acceptAceptation = false;
    this.expandedTextarea.hasVoiceRecord = false
    this.expandedTextarea.voiceRecord = {};
    this.expandedTextarea.text = '';
  }

  openModalRelatedInfo(relatedInfo:any, e:any){
    e.stopPropagation();
    e.preventDefault();
    this.modalService.relatedInformationModal(relatedInfo);
  }

  recordVoice(){
    this.modalService.recordAudioModal(this.concept)
      .subscribe((result:any)=>{
        if(result.result ==='ok'){
          this.configureVoiceRecord(result);
        }
      })
  }

  configureVoiceRecord(result:any){
    this.expandedTextarea.hasVoiceRecord = true;
    this.expandedTextarea.voiceRecord = {
      player: result.player,
      maxTime: result.maxTime,
      text: result.text,
      secondsRecord: result.secondsRecord,
      name: result.name,
      recordingFile: result.recordingFile,
      file: result.file
    }
    this.expandedTextarea.audioLoaded = true;
    this.expandedTextarea.text = result.text;
  }

  playRecordVoice(){
    this.startAudio = !this.startAudio;
    if(this.startAudio){
      this.initInterval = 0;
      this.initStartAudio()
    }else{
      this.stopInterval()
    }
  }

  audioDownLoad(){
    const url = URL.createObjectURL(this.expandedTextarea.voiceRecord.recordingFile);
	  const anchor = document.createElement("a");
	  anchor.download = this.expandedTextarea.voiceRecord.name;
	  anchor.href = url;
	  anchor.click();
  }

  acceptAceptationTerms(){
    if(!this.field.noEditable){
      this.expandedTextarea.acceptAceptation = !this.expandedTextarea.acceptAceptation;
      if(this.expandedTextarea.acceptAceptation){
        this.field.errorInAcceptAceptation = false;
      }
    }
  }

  initStartAudio(){
    this.expandedTextarea.voiceRecord.player.play();
    this.interval = setInterval(() => {
      this.percentTime = this.initInterval * 100 / this.expandedTextarea.voiceRecord.secondsRecord;
      if(this.percentTime >= 100){
        this.stopInterval()
      }else{
        this.initInterval++
      }
    }, 1000);
    this.startAudio = true;
  }

  stopInterval(){
    this.initInterval = 0;
    this.percentTime = 0;
    this.startAudio = false;
    this.expandedTextarea.voiceRecord.player.pause();
    this.expandedTextarea.voiceRecord.player.currentTime = 0;
    clearInterval(this.interval)
  }

  handleAccept(e:Event) {
    e.stopPropagation();
    if(this.expandedTextarea.hasVoiceRecord){
      this.stopInterval();
    }
    this.dialogRef.close({
      result:'ok',
      inputText: this.expandedTextarea.text,
      voiceRecord: this.expandedTextarea.voiceRecord,
      acceptAceptation: this.expandedTextarea.acceptAceptation
    })
  }
}
